import React from 'react';

import { useStyles } from './styles';

export const MapContainer = ({ children }: MapContainerProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {children}
    </div>
  );
};

interface MapContainerProps {
  children: React.ReactNode;
}
